// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ucsgnpuirkqnxgftqlfq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVjc2ducHVpcmtxbnhnZnRxbGZxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY2ODk0ODksImV4cCI6MjA1MjI2NTQ4OX0.IAdPyljLzvfhQRYiTDpSMGEAhSNbn9crlGkVvJZQj8Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);